import { useEffect, useState } from "react"
import parse from 'html-react-parser'
import { Wrapper, Header, TextsSection, FrameWrapper, HeadingColor, FrameReadingLeft, FrameReadingRight, RightFrameWrapper, ImageWrapper, Image, TextReading, SentenceWrapper, Question, Correct, ReadingInput } from "./ReadingTextsStyle"
import { ReadingTextData } from "./ReadingTextsData"
import { colors } from "../../../components/01_config/Colors"
import Topics from "../04_topics/Topics"
import useInstantScroll from "../../../hooks/useInstalntScroll"
import ToTheTop from "../../../components/04_common/02_tothetop/ToTheTop"
import { useSelector } from "react-redux"
import { reading } from "../../../i18n/07_reading"


const ReadingTexts = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = reading[lang]

    const [isGuest, setIsGuest] = useState(false)

    const [readingText, setReadingText] = useState(
        ReadingTextData)


    const { jumpToHash } = useInstantScroll();

    const { lessons } = useSelector(state => state.studentLessons)

    const role = useSelector((s) => s.auth?.user?.role); // ✅ add
    const isPrivileged = role === "TEACHER" || role === "ADMIN"; // ✅ add

    const isLessonUnlocked = (lessonNumber) => {

        // ✅ TEACHER/ADMIN: show everything
        if (isPrivileged) return true;

        if (!lessons || lessons.length === 0) {
            return lessonNumber === 0
        }

        const lesson = lessons.find((l) => l.order === lessonNumber)
        return !!lesson?.isUnlocked
    }

    const clickLesson = (lessonNumber) => {
        if (!isLessonUnlocked(lessonNumber)) return
        jumpToHash(`#lesson-${lessonNumber}`)
    }

    const clickQuestion = (textId, questionIndex) => {
        setReadingText(prev =>
            prev.map(value =>
                value.id === textId
                    ? {
                        ...value,
                        questions: value.questions.map((q, i) =>
                            i === questionIndex
                                ? {
                                    ...q,
                                    visibility:
                                        q.visibility === "visible" ? "hidden" : "visible",
                                }
                                : q
                        ),
                    }
                    : value
            )
        )
    }

    const fillInput = (textId, questionIndex, newValue) => {
        setReadingText(prev =>
            prev.map(text =>
                text.id === textId
                    ? {
                        ...text,
                        questions: text.questions.map((q, i) =>
                            i === questionIndex
                                ? { ...q, input: newValue }
                                : q
                        )
                    }
                    : text
            )
        );
    };

    useEffect(() => {
        setIsGuest(!lessons || lessons.length === 0);
    }, [lessons]);

    return (
        <Wrapper>
            <Header
            >
                {t.readingTextsHeader}
            </Header>
            <Topics
                isGuest={isGuest}
                clickLesson={clickLesson}
                isLessonUnlocked={isLessonUnlocked}
            />
            {readingText.map((value, index) => {
                const lessonNumber = index + 1
                if (!isLessonUnlocked(lessonNumber)) {
                    return null
                }


                return (
                    <TextsSection
                        key={index}
                        id={`lesson-${lessonNumber}`}
                    >
                        <HeadingColor>
                            Lesson {lessonNumber}
                        </HeadingColor>
                        <FrameWrapper>
                            <FrameReadingLeft>
                                <TextReading>{parse(value.text)}</TextReading>
                            </FrameReadingLeft>
                            <RightFrameWrapper>
                                <FrameReadingRight>
                                    <ImageWrapper>
                                        <Image src={value.image} />
                                    </ImageWrapper>
                                </FrameReadingRight>
                                <FrameReadingRight>
                                    {value.questions.map((val, ind) => (
                                        <SentenceWrapper key={ind}>
                                            <Question
                                                id={ind}
                                                onClick={() => clickQuestion(value.id, ind)}
                                            >
                                                {val.question}
                                            </Question>
                                            &nbsp;
                                            <ReadingInput
                                                style={{ color: val.input === val.answer ? `${colors.greenWord}` : "" }}
                                                value={val.input}
                                                id={ind}
                                                onInput={(e) => fillInput(value.id, ind, e.target.value)}
                                            />
                                            <Correct style={{ visibility: val.visibility }}>{val.answer}</Correct>
                                        </SentenceWrapper>
                                    ))}
                                </FrameReadingRight>
                            </RightFrameWrapper>
                        </FrameWrapper>
                    </TextsSection>
                )
            })}
            <ToTheTop />
        </Wrapper>
        // <FrameWrapper>
        //     <FrameReadingLeft>
        //         <TextReading>{parse(readingText[0].text)}</TextReading>
        //     </FrameReadingLeft>
        //     <RightFrameWrapper>
        //         <FrameReadingRight>
        //             <ImageWrapper>
        //                 <Image src={readingText[0].image} />
        //             </ImageWrapper>
        //         </FrameReadingRight>
        //         <FrameReadingRight>
        //             {readingText[0].questions.map((value, index) => (
        //                 <SentenceWrapper key={index}>
        //                     <Question
        //                         id={index}
        //                         onClick={clickQuestion}
        //                     >
        //                         {value.question}
        //                     </Question>
        //                     &nbsp;
        //                     <ReadingInput
        //                         style={{ color: value.input === value.answer ? `${colors.greenWord}` : "" }}
        //                         value={value.input}
        //                         id={index}
        //                         onInput={fillInput}
        //                     />
        //                     <Correct style={{ visibility: value.visibility }}>{value.answer}</Correct>
        //                 </SentenceWrapper>
        //             ))}
        //         </FrameReadingRight>
        //     </RightFrameWrapper>
        // </FrameWrapper>
    )
}

export default ReadingTexts